// src/pages/services/CreateService.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditService from "../../components/services/FormAddEditService";

const CreateService = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/services");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditService
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateService;
